// extracted by mini-css-extract-plugin
export default {"productsContainer":"style_productsContainer__PTfiw","category":"style_category__bB35Y","productList":"style_productList__po4+m"};